import gql from 'graphql-tag';

const NAME = 'compositions_CaseActivityPanel_Notes_removeCaseNoteMutation';

export default gql`
  mutation ${NAME} (
    $ids: [ID!]!
  ) {
    removeCaseNote(
      input: {
        ids: $ids
      }
    ) {
      deletedCount
    }
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/CaseActivityPanel/Notes/withRemoveCaseNote/removeCaseNoteMutation.js